module.exports = __webpack_public_path__ + "3c148fb5596ed42139dd0ab20385ca4d.svg";